import { Box, IconButton, Modal } from "@mui/material";
import { MyCloseIcon } from "../../Assets/svg/MyIcons";
import RichHtml from "../../components/Common/RichHtml";
// import CloseIcon from "@mui/icons-material/Close";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "60%",
  maxHeight: "80vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 0, // Remove padding from outer box, we'll handle it inside
  borderRadius: 2,
  overflow: "hidden", // Ensure header doesn't scroll
};

const headerStyle = {
  position: "sticky",
  top: 0,
  backgroundColor: "#fff",
  zIndex: 10,
  padding: "16px 24px",
  borderBottom: "1px solid #ddd",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
};

const bodyStyle = {
  padding: "16px 24px",
  fontSize: "14px",
  lineHeight: "1.6",
  maxHeight: "calc(80vh - 65px)", // Adjust height based on header
  overflowY: "auto",
};

const TermsAndConditionPreviewModal = ({ open, handleClose, contentData }) => {
  if (!contentData) return null;

  return (
    <Modal
      open={open}
      onClose={handleClose}
    >
      <Box sx={modalStyle}>
        <div style={headerStyle}>
          <h2 style={{ margin: 0 }}>{contentData.title}</h2>
          <IconButton onClick={handleClose}>
            <MyCloseIcon />
          </IconButton>
        </div>
        <Box sx={bodyStyle}>
          <RichHtml html={contentData.content} />
        </Box>
      </Box>
    </Modal>
  );
};

export default TermsAndConditionPreviewModal;
